import { Table } from "@zendeskgarden/react-tables";
import { DotLoader } from "react-spinners";
import * as Css from "./style";
import SelectDefault from "../../../ui/Select/Select";
import InputDateDefault from "../../../ui/InputDate";
import { DownloadReport } from "../downloadReport";
import { useContentHome } from "./useContentHome";

export default function ContentHome() {
    const { records, filters, setFilters, clearFilters, isLoading, optionsAction, optionsActionType, requesterOptions, usersMap, handleDownloadReport } = useContentHome()

    return (
        <Css.ContainerContent>
            <Css.ContainerTitle>
                <Css.ContainerType>
                    <p>Histórico</p>
                    {!!records.length && <span>{records.length}</span>}
                </Css.ContainerType>
                <DownloadReport onDownload={handleDownloadReport} />
            </Css.ContainerTitle>

            <Css.Content>


                <Css.StyledContainer>
                    <Css.Filters>
                        <SelectDefault
                            label="Ação realizada"
                            options={optionsAction}
                            initialOption="Selecione uma ação"
                            onChange={v => setFilters(f => ({ ...f, action: v }))}
                            value={filters.action ?? ""}
                        />

                        <SelectDefault
                            label="Tipo"
                            options={optionsActionType}
                            initialOption="Selecione um tipo"
                            onChange={v => setFilters(f => ({ ...f, action_type: v }))}
                            value={filters.action_type ?? ""}
                        />

                        <SelectDefault
                            label="Quem fez"
                            options={requesterOptions}
                            initialOption="Selecione alguém"
                            onChange={v =>
                                setFilters(f => ({
                                    ...f,
                                    requester: v
                                }))
                            }
                            value={filters.requester ?? ""}
                        />


                        <InputDateDefault
                            label="Data de início"
                            placeholder="dd/mm/aaaa"
                            value={filters.startDate ?? undefined}
                            onChange={date =>
                                setFilters(f => ({ ...f, startDate: date }))
                            }
                        />

                        <InputDateDefault
                            label="Data final"
                            placeholder="dd/mm/aaaa"
                            value={filters.endDate ?? undefined}
                            onChange={date =>
                                setFilters(f => ({ ...f, endDate: date }))
                            }
                        />


                        <div onClick={clearFilters} className="clear">Limpar</div>
                    </Css.Filters>

                    {isLoading ? (
                        <Css.State>
                            <DotLoader
                                color="#87929D"
                                loading={isLoading}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </Css.State>
                    ) : records.length === 0 ? (
                        <Css.State>
                            <p>
                                Nenhum histórico encontrado
                            </p>
                        </Css.State>
                    ) : (
                        <Css.TableWrapper>
                            <Css.TableStyles>
                                <Table>
                                    <Table.Head>
                                        <Table.HeaderRow>
                                            <Table.HeaderCell>Usuário</Table.HeaderCell>
                                            <Table.HeaderCell>Ação</Table.HeaderCell>
                                            <Table.HeaderCell>Tipo</Table.HeaderCell>
                                            <Table.HeaderCell>Quantidade</Table.HeaderCell>
                                            <Table.HeaderCell>Data da ação</Table.HeaderCell>
                                        </Table.HeaderRow>
                                    </Table.Head>

                                    <Table.Body>
                                        {records.map(r => (
                                            <Table.Row key={r.id}>
                                                <Table.Cell>
                                                    {usersMap[Number(r.custom_object_fields.requester)] ?? "-"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {r.custom_object_fields.action === "create"
                                                        ? "Criação massiva"
                                                        : "Edição massiva"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {r.custom_object_fields.action_type === "ticket"
                                                        ? "Ticket"
                                                        : r.custom_object_fields.action_type === "user"
                                                            ? "Usuário"
                                                            : "Organização"}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {r.custom_object_fields.success_count}
                                                </Table.Cell>

                                                <Table.Cell>
                                                    {new Date(r.updated_at).toLocaleString("pt-BR")}
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            </Css.TableStyles>
                        </Css.TableWrapper>
                    )}
                </Css.StyledContainer>
            </Css.Content>
        </Css.ContainerContent>
    );
}
